export enum WorkerMessageType {
  Start = 'Start',
  Stop = 'Stop',
  Process = 'Process',
}

export interface LiveKitProcessorWorkerMessage {
  type: WorkerMessageType;
  frameRate?: number;
}

export interface LiveKitProcessorServiceWorkerLocalScope extends ServiceWorkerGlobalScope {
  postMessage(message: LiveKitProcessorWorkerMessage): void;
  addEventListener: ServiceWorkerGlobalScope['addEventListener'];
}
